import { Button } from '@limitless-minds/ui-button'
import { Paragraph } from '@limitless-minds/ui-text'
import { Box, Stack, useTheme } from '@mui/material'

interface BodyProps {
  secondButtonOnClick?: () => void
  secondButtonMessage?: string
  buttonOnClick?: () => void
  buttonMessage?: string
  image: string
  imageAlt: string
  title: string
  description: string
  hideButtonOnDesktop?: boolean
}

const InfoComponent: React.FC<BodyProps> = ({
  buttonOnClick,
  buttonMessage,
  secondButtonOnClick,
  secondButtonMessage,
  image,
  imageAlt,
  title,
  description,
  hideButtonOnDesktop,
}) => {
  const theme = useTheme()
  return (
    <Stack width='100%' gap='2rem'>
      <Box
        width='100%'
        display='flex'
        justifyContent='center'
        gap='2rem'
        alignItems='center'
        flexDirection={{ xs: 'column', md: 'column', lg: 'row' }}
      >
        <img src={image} alt={imageAlt} width={106} height={108} />
        <Stack gap='0.5rem' textAlign={{ xs: 'center', md: 'center', lg: 'start' }}>
          <h1 style={{ color: theme.palette.role.onSurface }}>{title}</h1>
          <Paragraph variant='p16' color={theme.palette.role.onSurfaceVariant}>
            {description}
          </Paragraph>
        </Stack>
      </Box>
      {buttonOnClick && (
        <Button
          onClick={buttonOnClick}
          width='100%'
          sx={{
            display: {
              xs: 'block',
              md: hideButtonOnDesktop ? 'none' : 'block',
              lg: hideButtonOnDesktop ? 'none' : 'block',
            },
          }}
        >
          {buttonMessage}
        </Button>
      )}
      {secondButtonOnClick && (
        <button onClick={secondButtonOnClick} style={{ background: 'none', border: 'none', cursor: 'pointer' }}>
          <Paragraph variant='p16' underlined bold color={theme.palette.role.primary}>
            {secondButtonMessage}
          </Paragraph>
        </button>
      )}
    </Stack>
  )
}

export default InfoComponent
